import React, { useState } from 'react';

interface ManualQRInputProps {
  onValidate: (qrData: string) => void;
  isLoading: boolean;
  isVisible: boolean;
  onToggle: () => void;
}

const ManualQRInput: React.FC<ManualQRInputProps> = ({
  onValidate,
  isLoading,
  isVisible,
  onToggle,
}) => {
  const [qrData, setQrData] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (qrData.trim()) {
      onValidate(qrData.trim());
      setQrData('');
    }
  };

  return (
    <div className="bg-white rounded-lg shadow-md p-4 md:p-6 mb-6">
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-lg md:text-xl font-semibold text-gray-800">Manual Ticket Input</h2>
        <button
          onClick={onToggle}
          className="text-blue-600 hover:text-blue-700 text-sm font-medium"
        >
          {isVisible ? 'Hide' : 'Show'} Manual Input
        </button>
      </div>

      {isVisible && (
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label htmlFor="qr-data" className="block text-sm font-medium text-gray-700 mb-2">
              Enter Ticket Number, Transaction ID, or Ticket URL
            </label>
            <input
              type="text"
              id="qr-data"
              value={qrData}
              onChange={(e) => setQrData(e.target.value)}
              placeholder="Enter ticket UUID, transaction ID (TXN-xxx), or ticket URL"
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              disabled={isLoading}
            />
          </div>
          <button
            type="submit"
            disabled={isLoading || !qrData.trim()}
            className={`w-full bg-blue-600 text-white py-2 px-4 rounded-lg hover:bg-blue-700 text-sm font-medium ${
              isLoading || !qrData.trim() ? 'opacity-50 cursor-not-allowed' : ''
            }`}
          >
            {isLoading ? 'Validating...' : 'Validate Ticket'}
          </button>
        </form>
      )}
    </div>
  );
};

export default ManualQRInput;
